export default __webpack_public_path__ + "static/media/guLogo.24ccf122.png";